module.exports = __webpack_public_path__ + "img/x.cc06226a.svg";